import React from "react";
import ApplyCoupon from "./applyCoupon";
import { Button } from "antd";
import { Link } from "react-router-dom";

const fareDetail = () => {
  return (
    <section className="booking-detail fareDetail">
      <div className="fare-heading-wrap  ">
        <div className=" d-flex justify-content-between fare-detail-content-title">
          Fare Details
          <div className="apply-coupen">
            <ApplyCoupon />
          </div>
        </div>

        <div className="fare-detail-content ">
          <div className="fare">Base fare</div>
          <div className="price">₹3,220 </div>
        </div>

        {/* <div className="fare-detail-content ">
          <div className="fare">Doorstep delivery & pickup</div>
          <div className="price">₹400 </div>
        </div> */}

        <div className="fare-detail-content ">
          <div className="fare">Insurance & GST</div>
          <div className="price">included</div>
        </div>

        <div className="fare-detail-content ">
          <div className="fare">Refundable security deposit</div>
          <div className="price">₹2,500 </div>
        </div>

        <div className="fare-detail-content  total-fare">
          <div className="fare total-highlight">Total</div>
          <div className="price total-highlight">₹6,120 </div>
        </div>

        <div >
          <div className="summary-btn  ">
          <div className="btn-wrap w-100">
          <Link to="/faresummary">
              <Button type="primary " className="fare-btn-wrap checkout w-100">CHECKOUT SUMMARY</Button>
            </Link>
        
          </div>
            

          <div className="btn-wrap w-100">
            <Link to="">
              <Button type="danger " className="fare-btn-wrap cancel-booking w-100">CANCEL BOOKING</Button>
            </Link>
          </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default fareDetail;
